import instanceQuery from 'graphql/queries/salesLedger/SalesBadDebtPostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const SalesBadDebtPostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default SalesBadDebtPostingPreview;
